export default __webpack_public_path__ + "static/nipun-58462e0cc55a2355b795fa9c2f2cb72a.png";